/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportScheduleDto } from '../../models/report-schedule-dto';
import { UpdateReportScheduleRequest } from '../../models/update-report-schedule-request';

export interface ReportSchedulesScheduleIdPut$Json$Params {
  scheduleId: string;
      body?: UpdateReportScheduleRequest
}

export function reportSchedulesScheduleIdPut$Json(http: HttpClient, rootUrl: string, params: ReportSchedulesScheduleIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, reportSchedulesScheduleIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('scheduleId', params.scheduleId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportScheduleDto>;
    })
  );
}

reportSchedulesScheduleIdPut$Json.PATH = '/report-schedules/{scheduleId}';
